import React from 'react';
import { useDocumentation, DocumentationProvider } from '../contexts/DocumentationContext';
import './Documentation.css';

// Import optimized components
import DirectLinkHandler from './documentation/DirectLinkHandler';
import DocNavigation from './documentation/DocNavigation';
import ContentRenderer from './documentation/ContentRenderer';
import SearchBox from './documentation/SearchBox';

// Main Documentation content component (using the context)
function DocumentationContent() {
  const {
    activeSection,
    activeSubsection,
    expandedSections,
    isSearching,
    searchQuery,
    contentRef,
    navigateToSection,
    navigateToSubsection,
    toggleSection
  } = useDocumentation();

  return (
    <div className="documentation">
      <div className="documentation-container">
        {/* Sidebar */}
        <aside className="docs-sidebar">
          <SearchBox />

          {isSearching && searchQuery.length >= 2 ? (
            null // SearchBox component handles rendering search results
          ) : (
            <DocNavigation
              activeSectionId={activeSection}
              activeSubsectionId={activeSubsection}
              expandedSections={expandedSections}
              onSectionClick={toggleSection}
              onSectionNavigate={navigateToSection}
              onSubsectionNavigate={navigateToSubsection}
            />
          )}
        </aside>

        {/* Content Area */}
        <main className="docs-content" ref={contentRef}>
          <ContentRenderer
            activeSectionId={activeSection}
            activeSubsectionId={activeSubsection}
          />
        </main>
      </div>
    </div>
  );
}

// Wrapper component that provides the context
function Documentation() {
  return (
    <DocumentationProvider>
      <DirectLinkHandler />
      <DocumentationContent />
    </DocumentationProvider>
  );
}

export default Documentation;